export * from "./webgpuClearQuad.pure";

import "../../ShadersWGSL/clearQuad.vertex";
import "../../ShadersWGSL/clearQuad.fragment";
